module.exports = __webpack_public_path__ + "img/side-entrance.f1336d8b.jpg";